<template>
  <div
    v-if="show"
    :class="$.gradient"
  />
</template>

<script>
export default {
  props: {
    show: { type: Boolean, default: false },
  },
  data() {
    return {};
  },
};
</script>

<style module='$' lang='less'>
.gradient {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 26px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 100%);
}
</style>
